import styled from 'styled-components';

const VehicleDriverInfoWrapper = styled.div`


`;

export default VehicleDriverInfoWrapper;